import { createContext, useContext } from "react";

import { type CustomerEligibilityOutput } from "@/types/types";

export type PaymentType = "standard" | "bnpl";

export type PaymentContextType = {
  paymentType: PaymentType;
  selectedInstallments: number;
  availableInstallments: number[];
  maxAvailableInstallments: number;
  isEligibilityLoading: boolean;
  isEligibilityFetching: boolean;
  isEligible: boolean | null;
  sessionId: string | null;
  handlePaymentTypeChange: (type: PaymentType) => void;
  setInstallments: (value: number) => void;
  refreshSession: () => Promise<{
    data: CustomerEligibilityOutput | undefined;
    isLoading: boolean;
  }>;
};

export const PaymentContext = createContext<PaymentContextType | null>(null);

export const usePaymentContext = () => {
  const context = useContext(PaymentContext);

  if (!context) {
    throw new Error("usePaymentContext must be used within PaymentProvider");
  }
  return context;
};
